import axios, { AxiosResponse } from 'axios'
import { ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { ReportGridRequest } from '@/api/services/common.dto'

class ShipmentsItemExporterService {
    // Exports in PDF a list of pending elements to be received in a laboratory
    async exportPendingToBeReceived(
        destinationLaboratoryId: number,
        gridColumns?: ReportGridRequest,
        params?: ExportCommonParams
    ): Promise<AxiosResponse<Blob>> {
        return axios.put<Blob>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItemsPendingToBeReceived/export`,
            { ...gridColumns },
            { params, responseType: 'arraybuffer' })
    }

    // Exports in PDF a list of received elements in a laboratory
    async exportReceived(
        destinationLaboratoryId: number,
        gridColumns?: ReportGridRequest,
        params?: ExportCommonParams
    ): Promise<AxiosResponse<Blob>> {
        return axios.put<Blob>(
            `/shipments/laboratories/${destinationLaboratoryId}/shipmentItemsReceived/export`,
            { ...gridColumns },
            { params, responseType: 'arraybuffer' })
    }

    // Exports in PDF a list of sent elements in a laboratory
    async exportSent(
        originLaboratoryId: number,
        gridColumns?: ReportGridRequest,
        params?: ExportCommonParams
    ): Promise<AxiosResponse<Blob>> {
        return axios.put<Blob>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentItemsSent/export`,
            { ...gridColumns },
            { params, responseType: 'arraybuffer' })
    }
}

export const shipmentsItemExporterService = new ShipmentsItemExporterService()
